import BootStrapDialog from "../helpers/BootStrapDialog";
import BootstrapDialogTitle from "../helpers/BootstrapDialogTitle";
import {  Checkbox, CircularProgress, DialogActions, DialogContent,  ListItem, ListItemButton,  } from "@mui/material";
import React, { useEffect } from "react";
import EmployeeTile from "./EmployeeTile";
import Button from "@mui/material/Button";
import secureLocalStorage from "react-secure-storage";

const SelectEmployee = (props) => {
    const { open, onClose, getEmployees, confirm, selectedEmployees, resources,onChange } = props;

    const settings = secureLocalStorage.getItem("systemSettings");
    const settingsInfo = JSON.parse(settings);
    const mainBackground = settingsInfo?.mainBackground || '#526680';

    const [loading, setLoading] = React.useState(true);
    const [list, setList] = React.useState([]);
    const [category, setCategory] = React.useState('All');

    const [checked, setChecked] = React.useState(selectedEmployees ?? []);
    const [search, setSearch] = React.useState("");
    const trim = search?.trim()?.toLowerCase();

    const listByCategory = category !== 'All' ? list?.filter(item => item.category === category) : list
    const newList = trim ? listByCategory?.filter(v => v.email?.toLowerCase()?.includes(trim) || v.names?.toLowerCase()?.includes(trim)) : listByCategory;


    useEffect(()=>setChecked(selectedEmployees??[]),[selectedEmployees]);

    const handleToggle = (value) => {
        if(typeof onChange === 'function'){
            onChange(value);
        }
        const currentIndex = checked.findIndex(el => el.id === value.id);
        const newChecked = checked.filter(v => v.id !== value.id);
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const onCheckAll = () => {
        if (checked.length !== newList?.length) {
            setChecked(newList);
        } else {
            setChecked([]);
        }
    };
    useEffect(() => setList(resources), [resources]);

    const select = () => {
        onClose();
        confirm(checked);
    }

    useEffect(() => {
        // loadEmployees().then();
    }, [getEmployees, search]);

    return <div>
        <BootStrapDialog open={open} fullWidth={true} maxWidth={'sm'} onClose={onClose}>
            <BootstrapDialogTitle id={"employee-selector"} onClose={onClose}>Select Employees</BootstrapDialogTitle>
            <DialogContent>
                {!loading ?
                    <div className={'text-center p-5'}>
                        <CircularProgress />
                    </div> :
                    <div>
                        <div className={'mb-3'}>
                            {/* <label >Category</label>
                            <select
                                value={category}
                                className={'form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'} onChange={(e) => setCategory(e.target.value)}>
                                {['All', 'CEO', 'Analyst', 'Architect', 'Database', 'Finance', 'Hr', 'Lead Project Manager', 'Project Manager', 'Management', 'Security', 'Developer', 'DevOps'].map((item) =>
                                    <option value={item}>{item}</option>
                                )}

                            </select> */}
                        </div>
                        <div className={'flex'}>
                            <div className={'flex-grow mr-3'}>
                                    <input type={'search'} value={search} onChange={(e) => setSearch(e.target.value)}
                                           className={'px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'} placeholder={'Search here .....'} />
                            </div>
                            <span>
                                <Checkbox
                                    edge="start"
                                    tabIndex={-1}
                                    checked={checked?.length === newList?.length}
                                    onChange={() => {
                                        onCheckAll();
                                    }}
                                    disableRipple
                                    sx={{
                                        color: "#526680",
                                        '&.Mui-checked': {
                                            color: '#526680'
                                        },
                                    }}
                                />
                            </span>
                        </div>
                        {newList?.map(v => {
                            return <EmployeeTile employee={v}
                                selected={checked?.findIndex(el => el.id === v.id) !== -1} handleToggle={handleToggle} />
                        })}
                    </div>}
            </DialogContent>
            <DialogActions>
                <Button color={'error'} onClick={onClose}>Cancel</Button>
                <Button
                    color={'success'}
                    onClick={() => select()}
                    style={{ backgroundColor: mainBackground}}
                    variant={'contained'}>Add Employees</Button>
            </DialogActions>
        </BootStrapDialog>
    </div>
}


export default SelectEmployee;
